require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-cynthia-wang.json") })
        }
      }, "path---blog-author-cynthia-wang");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-cynthia-wang!./.cache/json/blog-author-cynthia-wang.json
// module id = 619
// module chunks = 231608221292675